import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Box } from "@ui/wrapper"
import Button from "@ui/button"
import { slugify, flatDeep } from "@utils/utilFunctions"

const Categories = ({ boxStyle, tagStyle }) => {
  const BlogCateQuery = useStaticQuery(graphql`
    query BlogSidebarCateQuery {
      allMarkdownRemark(filter: { frontmatter: { type: { eq: "blog" } } }) {
        edges {
          node {
            frontmatter {
              categories
            }
          }
        }
      }
    }
  `)

  const cate = BlogCateQuery.allMarkdownRemark.edges
  let cateObjList = cate.map(cat => cat.node.frontmatter)
  let cateListArr = cateObjList.map((cat, i) => cat.categories)
  let cateList = flatDeep(cateListArr)
  let cateListSet = new Set(cateList)
  let cateArr = Array.from(cateListSet)

  return (
    <Box {...boxStyle}>
      {cateArr.map((cat, i) => {
        return (
          <Button {...tagStyle} to={`/categories/${slugify(cat)}`} key={slugify(cat)}>
            {cat}
          </Button>
        )
      })}
    </Box>
  )
}

Categories.propTypes = {
  tagStyle: PropTypes.object,
}

Categories.defaultProps = {
  boxStyle: {
    m: "-5px",
  },
  tagStyle: {
    hover: "2",
    size: "xsmall",
    skin: "light",
    color: "#ababab",
    bgcolor: "#f5f5f5",
    p: "0 14px",
    m: "5px",
    height: "32px",
    lineheight: "32px",
    fontSize: "13px",
  },
}

export default Categories
